import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DirectionKindEnum } from '@zaoblako/shared/modules/catalog/enums/direction.kind.enum';
import { DirectionKindEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/direction.kind.enum.i18n';

@Pipe({
  standalone: true,
  name: 'directionKindName'
})
export class DirectionKindNamePipe implements PipeTransform {
  public transform(directionKind: DirectionKindEnum): string {
    return DirectionKindEnumI18n[I18nLocalesEnum.RU_RU][directionKind];
  }
}
